module.exports = __webpack_public_path__ + "static/img/b6_footer.8c0fe74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b6_footer.png
// module id = IP5U
// module chunks = 1